/**
 * Copyright (c) 2017 CRF Box Oy. All Rights Reserved. Company Confidential.
 */
import { connect } from 'react-redux';
import { hideModal, showModal } from '../../../actions/actions';
import ConfirmationArchiveExportModal from './confirmation-archive-export.modal';

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    close: () => {
      dispatch(hideModal());
    }
  };
};

const ConfirmationArchiveExportModalContainer = connect(null, mapDispatchToProps)(ConfirmationArchiveExportModal);
export default ConfirmationArchiveExportModalContainer;
